var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { mockData as documentEventsData } from '@web/lib/demo/data/documentEvents';
import { filterData, getUsers } from '@web/lib/demo/utils';
import { analyticDriveActivity } from '@workalizer/shared/services/analyticDriveActivity';
export var driveActivity = function (input) {
    var users = getUsers({
        userId: input.userId
    });
    var documentEvents = filterData(documentEventsData, [
        {
            key: 'date',
            value: input.dateFrom,
            operator: 'gt'
        },
        {
            key: 'date',
            value: input.dateTo,
            operator: 'lt'
        },
        {
            key: 'userId',
            value: users.map(function (user) { return user.id; }),
            operator: 'in'
        }
    ]).map(function (item) { return (__assign(__assign({}, item), { date: new Date(item.date), createdAt: new Date(item.createdAt), updatedAt: new Date(item.updatedAt) })); });
    var documents = documentEvents.reduce(function (acc, item) {
        if (!acc.find(function (doc) { return doc.id === item.documentId; })) {
            acc.push({
                id: item.documentId,
                title: item.document.title,
                type: item.document.type
            });
        }
        return acc;
    }, []);
    var groupedEvents = documentEvents.reduce(function (acc, item) {
        if (!acc.find(function (event) { return event.documentId === item.documentId; })) {
            acc.push({
                documentId: item.documentId,
                action: item.action,
                _count: {
                    action: 1
                }
            });
        }
        return acc;
    }, []);
    var groupedData = analyticDriveActivity(documents, groupedEvents);
    return groupedData;
};
